module.exports = __webpack_public_path__ + "img/samba.d95b0e7d.png";